import React from 'react';
import DownloadPdf from '../../../components/DownloadPdf';
import NumberFormatter from '../../../components/Formarts';
import BarChart from '../../../components/charts/BarChart';
import LineChart from '../../../components/charts/LineChart';
import TooltipModal from '../../../components/modals/ToolTipModal';

const TableConsumption = ({ data }) => {

  const customization = JSON.parse(localStorage.getItem('customizations'))
  const volumen = customization[0].custom[0].volumen
  // const currency = localStorage.getItem("currency")

  if (!data || data.length <= 0 || data.error || data === null || data == []) {
    return <p className="subtitle">Sin parámetros asignados</p>;
  }

  const extractChartData = (data) => {
    const values = data.map(item => item.present_value);
    return values;
  };

  let chartData;
  let secondChartData;

  if (data.length > 0) {
    chartData = extractChartData(data[0].annual_fuel_proyection.annual_proyection);
    secondChartData = extractChartData(data[0].annual_proyection.annual_proyection);
  }

  return (
    <div>
      {data.length > 0 && (
        <>

          <div className="father-box">
            <div className="child-box shadow-left">
              <div className="title">
                <h4 className='subtitle'>VEHÍCULO ELÉCTRICO </h4>
                <br />
              </div>
              <table className='table table-striped'>
                <tbody>
                  <tr>
                    <td>Energía nominal [kWh]</td>
                    <td className='col-4'><span className='result-text' ><NumberFormatter number={data[0].nominal_energy} /></span></td>
                  </tr>
                  <tr>
                    <td>Autonomía [km]</td>
                    <td className='col-4'><span className='result-text' >{data[0].autonomy} </span></td>
                  </tr>
                  <tr>
                    <td>Consumo de energía [kWh/km] <TooltipModal text={'Cantidad de energía consumida por el vehículo en un (1) kilómetro recorrido'} title={'Consumo de energía [kWh/km]'} /></td>
                    <td className='col-4'><span className='result-text' ><NumberFormatter number={data[0].electrical_consumption} /></span> </td>
                  </tr>
                  <tr>
                    <td>Costo de energía por kilómetro [$/km]</td>
                    <td className='col-4'><span className='result-text' >$ <NumberFormatter number={data[0].electrical_cost_km} /></span></td>
                  </tr>
                  <tr>
                    <td>Costo de energía mensual [$]</td>
                    <td className='col-4'><span className='result-text' >$ <NumberFormatter number={data[0].month_energy_cost} /></span></td>
                  </tr>
                </tbody>
              </table>
              <br />
              <div className="title">
                <h5>PROYECCIÓN DE CONSUMO DE VEHÍCULOS ELÉCTRICOS</h5>
                <br />
              </div>
              <table className="table table-striped-columns p-2">
                <tbody>
                  <tr>
                    <td className="table-head col-3">Año</td>
                    <td className="table-head">Proyección anual</td>
                  </tr>
                  {data[0].annual_proyection.annual_proyection.map((datas, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>$ <NumberFormatter number={datas['present_value']} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <h4 className="big-result-text">Total: $ <NumberFormatter number={data[0].annual_proyection.total} /></h4>
            </div>
            <div className="child-box shadow-left">
              <div className="title">
                <h4 className='subtitle'>VEHÍCULO A COMBUSTIÓN</h4>
                <br />
              </div>
              <table className='table table-striped'>
                <tbody>
                  <tr>
                    <td>Consumo de energía [kWh/km]</td>
                    <td className='col-4'><span className='result-text' ><NumberFormatter number={data[0].combustion_consumption} /></span></td>
                  </tr>
                  <tr>
                    <td>Consumo de combustible [{volumen}/km] <TooltipModal text={'Volumen de combustible consumidos por el vehículo durante un (1) kilómetro de recorrido'} title={`Consumo de combustible [${volumen}/km]`} /></td>
                    <td className='col-4'><span className='result-text' ><NumberFormatter number={(data[0].fuel_consumption)} /></span> </td>
                  </tr>
                  <tr>
                    <td>Rendimiento de combustible [km/{volumen}] <TooltipModal text={`Cantidad de kilómetros posibles de recorrer con un (1) ${volumen} de combustible`} title={`Rendimiento de combustible [km/${volumen}]`} /></td>
                    <td className='col-4'><span className='result-text' ><NumberFormatter number={(data[0].fuel_efficiency)} /></span> </td>
                  </tr>
                  <tr>
                    <td>Costo de combustible por kilómetro [$/km]</td>
                    <td className='col-4'><span className='result-text' >$ <NumberFormatter number={(data[0].fuel_cost_km)} /></span></td>
                  </tr>
                  <tr>
                    <td>Costo de combustible mensual [$]</td>
                    <td className='col-4'><span className='result-text' >$ <NumberFormatter number={data[0].monthFuelCost} /></span></td>
                  </tr>
                </tbody>
              </table>
              <br />
              <div className="title">
                <h5>PROYECCIÓN DE CONSUMO DE VEHÍCULOS A COMBUSTIÓN</h5>
                <br />
              </div>
              <table className="table table-striped-columns p-2">
                <tbody>
                  <tr>
                    <td className="table-head col-3">Año</td>
                    <td className="table-head">Proyección anual</td>
                  </tr>
                  {data[0].annual_fuel_proyection.annual_proyection.map((datas, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>$ <NumberFormatter number={datas['present_value']} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <h4 className="big-result-text">Total: $ <NumberFormatter number={data[0].annual_fuel_proyection.total} /> </h4>
            </div>
          </div>
          <div className="father-box">
            <div className="child-box shadow-left">
              <BarChart data={{
                categories: ['Consumo'],
                series: [
                  {
                    name: 'Eléctrico',
                    data: [parseFloat(data[0].annual_proyection.total)],
                  },
                  {
                    name: 'Combustión',
                    data: [parseFloat(data[0].annual_fuel_proyection.total)],
                  }
                ],
              }} />
            </div>

            <div className="child-box shadow-left">
              {chartData && secondChartData && (
                <LineChart data={[
                  {
                    name: 'Combustión',
                    data: chartData,
                  },
                  {
                    name: 'Eléctrico',
                    data: secondChartData,
                  }
                ]} />
              )}
            </div>
          </div>
        </>
      )}
      <br /><br />
    </div>
  );
};

export default TableConsumption;
